import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, IconButton, styled, Typography } from '@mui/material';
import { CustomButton } from 'src/components/button/Button';

export const Container = styled(Box)`
  margin: 30px;
`;

export const LinkContainer = styled(Button)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    min-height: auto;
    text-transform: none;
    background: transparent;
    & > a {
      color: ${theme.palette.primary.main};
    }
  `,
);

export const StyledPreviewButton = styled(CustomButton)(
  ({ theme }) => `
  color: ${theme.palette.primary.main};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4px;
`,
);

export const StyledExportButton = styled(CustomButton)(
  ({ theme }) => `
  color: ${theme.palette.primary.main};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4px;
`,
);

export const TitleText = styled(Typography)`
  font-size: 20px;
  font-weight: 500;
`;

export const ComponentNameContainer = styled(Box)`
  vertical-align: 'top';
`;

export const StyledExpandMoreIcon = styled(ExpandMoreIcon, {
  shouldForwardProp: (prop: string) => prop !== 'isExpanded',
})<{
  isExpanded: boolean;
}>(({ isExpanded }) => ({
  cursor: 'pointer',
  transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: 'transform 0.3s',
}));

export const StyledAccordionIconWrapper = styled(Box)`
  width: 80px;
`;

export const StyledAccordionIcon = styled(IconButton)`
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '50px',
});
